/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
     <v-breadcrumbs :items="breadcrumbs_items"></v-breadcrumbs>
     <v-row>
      <v-col col="12">
       <v-card style="margin:auto;" max-width="1244">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field label="Nome do Produto*" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Código*"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Descrição reduzida"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Código de Barra*"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <table style="width:100%;">
                 <tr>
                    <td  style="width:70%;">
                      <v-row>
                          <v-col cols="12" sm="6">
                          <v-select
                            :items="['0-17', '18-29', '30-54', '54+']"
                            label="Tipo de Produto*"
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select
                            :items="['0-17', '18-29', '30-54', '54+']"
                            label="Mercadoria*"
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select
                            :items="['0-17', '18-29', '30-54', '54+']"
                            label="Armazem*"
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select
                            :items="['0-17', '18-29', '30-54', '54+']"
                            label="Família"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>
                    </td>
                    <td>
                       <table style="width:100%;">
                            <tr>
                             <td style="width:95%;">
                                                <div style="border:1px solid black;width:250px;height:250px;margin-left:26px;">
                                                   <v-img style="width:250px;height:250px" :src="imageData" aspect-ratio="1.7"></v-img>
                                                </div>
                                            </td>
                                            <td>
                                                   <input @change="previewImage" type="file" ref="file" style="display: none">
                                                    <v-btn @click="$refs.file.click()" class="mx-2 btn_space" small fab dark color="primary">
                                                        <v-icon dark>add_a_photo</v-icon>
                                                    </v-btn>
                                                    <v-btn @click="imageData = ''" class="mx-2 btn_space" small fab dark color="primary">
                                                        <v-icon dark>remove</v-icon>
                                                    </v-btn>
                                            </td>
                            </tr>
                       </table>
                    </td>
                 </tr>
              </table>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      </v-col>
     </v-row>
     <v-row>
      <v-col col="12">
         <v-card style="margin:auto;" max-width="1244">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="preço de Custo" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                :items="items"
                label="Imposto*"
                filled
              ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                :items="items"
                label="Insenção de imposto"
                filled
              ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Margem(%)*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Preço sem Iva*"
                ></v-text-field>
              </v-col>
               <v-col cols="12" sm="6" md="4">
                <v-select
                :items="items"
                label="Imposto"
                filled
              ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                :items="items"
                label="Insenção de imposto"
                filled
              ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Preço com Iva"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      </v-col>
     </v-row>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    breadcrumbs_items:
    [
      {
        text: 'Home',
        disabled: false,
        to: '/welcome'
      },
      {
        text: 'Produtos',
        disabled: true
      },
      {
        text: 'Novo',
        disabled: true,
        href: 'breadcrumbs_link_2'
      }
    ],

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Preço descrição',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      { text: 'Margem', value: 'calories' },
      { text: 'Preço sem IVA', value: 'fat' },
      { text: 'IVA', value: 'carbs' },
      { text: 'Modo de isenção', value: 'protein' },
      { text: 'Preço com IVA', value: 'iron' },
      { text: 'Predifinido', value: 'iron' }
    ],
    headersPreco: [
      {
        text: 'Preço descrição',
        align: 'start',
        sortable: false,
        value: 'descricaoPreco'
      },
      { text: 'Margem', value: 'margem' },
      { text: 'Preço sem IVA', value: 'precoSemIva' },
      { text: 'IVA', value: 'iva' },
      { text: 'Modo de isenção', value: 'motivoIsencao' },
      { text: 'Preço com IVA', value: 'precoComIva' },
      { text: 'Predifinido', value: 'predifinido' }
    ],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      // eslint-disable-next-line no-dupe-keys
      bi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeTipoProdutos()
    this.initializeMercadoria()
    this.initializeArmazem()
    this.initializeFamiliaProduto()
    this.initializeTaxaIva()
    this.initializeIsencaoIva()
    this.initializePrecosDescricao()
  },

  methods: {
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },

    async initializeTipoProdutos () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.tipoProdutos = await axios
          .get('/tipoProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    async initializeMercadoria () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.mercadorias = await axios
          .get('/mercadoriaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeArmazem () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.armazem = await axios
          .get('/armazemFindall')
          .then(res => res.data)
        console.log(this.armazem)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeFamiliaProduto () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.familiaProduto = await axios
          .get('/FamiliaProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeTaxaIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.taxa_iva = await axios
          .get('/TaxaIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeIsencaoIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.descricao_isencao_iva = await axios
          .get('/IsencaoIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async initializePrecosDescricao () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.precosExtensao = await axios
          .get('/precosExtensaoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    SelecionaIvaVenda () {
      if (this.taxaIvaVendaSelected !== null) {
        if (this.taxaIvaVendaSelected === 0) {
          this.descricao_isencao_ivaFiltered = this.descricao_isencao_iva
          this.disabilita_ivaVenda = false
        } else {
          this.disabilita_ivaVenda = true
          this.descricao_isencao_ivaFiltered = []
        }
      }
    },

    SelecionaIvaCompra () {
      if (this.taxaIvaCompraSelected !== null) {
        if (this.taxaIvaCompraSelected === 0) {
          this.descricao_isencao_compraFiltered = this.descricao_isencao_iva
          this.disabilita_ivaCompra = false
        } else {
          this.disabilita_ivaCompra = true
          this.descricao_isencao_compraFiltered = []
        }
      }
    },

    SelecionaIvaPreco () {
      if (this.taxa_ivaPrecoSelected !== null) {
        if (this.taxa_ivaPrecoSelected === 0) {
          this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva
          this.disabilita_ivaPreco = false
        } else {
          this.disabilita_ivaPreco = true
          this.descricao_isencao_ivaprecoFiltered = []
        }
        this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
      }
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    SelecionaTipoServico () {
      if (this.tipoProdutoSelected !== null) {
        this.mercadoriasFiltered = this.mercadorias.filter(f => f.fk_tipoProduto === this.tipoProdutoSelected)
        console.log(this.mercadorias)

        this.mercadoria_disable = (this.tipoProdutoSelected !== 1)
      }
    },
    savePreco () {
      if (this.$refs.form.validate()) {
        let params =
          {
            descricaoPreco: (this.model.descricao !== undefined) ? this.model.descricao : this.model,
            margem: this.margemPreco,
            precoSemIva: this.ObterValorFormatado(this.precoSemIva),
            iva: this.taxa_ivaPrecoSelected,
            motivoIsencao: this.motivoIsencao,
            predifinido: this.predifinido,
            precoComIva: this.precoComIva
          }

        this.tabelas_preco.push(params)
        this.dialog = false
      }
    },

    async saveProduto () {
      if (this.$refs.form.validate()) {
        if (this.tabelas_preco.length) {
          let params =
        {
          codigo: this.codigoProduto,
          descricao: this.descricaoProduto,
          descricaoReduzida: this.descricaoReduzida,
          codigoBarra: this.codigoBarraSelected,
          armazem: this.armazemSelected,
          tipoProduto: this.tipoProdutoSelected,
          mercadoria: this.mercadoriaSelected,
          familia: this.familiaSelected,
          precoCusto: this.precoCustoSelected,
          precoComIva: this.precoComIvaInteiro,
          precoSemIva: this.precoSemIva,
          margem: this.margemPreco,
          iva: this.taxa_ivaPrecoSelected,
          isencao: this.motivoIsencao,
          descricaoPreco: (this.model.descricao !== undefined) ? this.model.descricao : this.model,
          pkPreco: (this.model.descricao !== undefined) ? this.model.pkPreco : 0
        }

          try {
            //   let  payload =""
            this.isLoading = true
            let msg = await axios
              .post('/produtoAdd', params)
              .then(res => res.data)

            if (!msg.length) {
              this.text = 'Produto adicionado com sucesso'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 5000 })
              this.reset()
            }
          } catch (error) {
            this.isLoading = false

            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }
        } else {
          this.text = 'Deve preencher os campos da aba Preço'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Limpar () {
      this.codigoProduto = ''
      this.descricaoProduto = ''
      this.descricaoReduzida = ''
      this.armazemSelected = ''
      this.tipoProdutoSelected = ''
      this.mercadoriaSelected = ''
      this.familiaSelected = ''
    },

    CalculaPreComIva (valor) {
      let valorIva = parseInt(this.precoSemIva) * valor
      let valorFinal = parseInt(this.precoSemIva) + valorIva
      this.precoComIva = valorFinal
      this.precoComIva = this.ObterValorFormatado(valorFinal)
      this.precoComIvaInteiro = valorFinal
    },

    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
